import { Text } from '@chakra-ui/react';

import { PRIVACY_POLICY, TERMS_AND_CONDITIONS } from '../../../constants/urls';
import {
  ConsentAgreementTypeEnum,
  ConsentNameEnumType,
  useCurrentConsentAgreementTextQuery,
  useSaveConsentMutation,
} from '../../../gql/generated/graphql';
import { Link } from '../../ui/links/Link';

const linkProps = {
  display: 'inline',
  color: 'royalBlue',
  fontSize: 'xs',
  letterSpacing: 'normal',
  textDecoration: 'underline',
};

// Without a dealId the resolver keys consent to the temp-info record, which migrates to the deal at import.
const useMarketplacePhoneConsent = (dealId?: string) => {
  const { data, loading } = useCurrentConsentAgreementTextQuery({
    variables: { agreementType: ConsentAgreementTypeEnum.MarketplaceSmsTextProgram },
  });

  const [saveConsentMutation] = useSaveConsentMutation();

  const saveConsent = async () => {
    await saveConsentMutation({
      variables: {
        type: ConsentNameEnumType.MarketplaceSmsTextProgram,
        ...(dealId ? { dealId } : {}),
      },
    });
  };

  const consentText = data?.currentConsentAgreementText?.text ?? '';

  const consentCopy = consentText ? (
    <Text fontSize="xs" color="gray.500" textAlign="left">
      {consentText} See our{' '}
      <Link to={TERMS_AND_CONDITIONS} isExternal {...linkProps}>
        Terms
      </Link>{' '}
      and{' '}
      <Link to={PRIVACY_POLICY} isExternal {...linkProps}>
        Privacy Policy
      </Link>
      .
    </Text>
  ) : null;

  return {
    consentCopy,
    consentLoading: loading && !consentText,
    saveConsent,
  };
};

export default useMarketplacePhoneConsent;
